"use client";
import { CommonContextProvider } from "@/contexts";
import { CommonFooter, CommonHeader } from "@/components";

export const PagesLayout = ({
    sectionsData,
    headerData,
    footerData,
    children,
    otherData,
    whatssAppConfig,
}) => {

    return (
        <>
            <CommonContextProvider {...otherData}>
                <CommonHeader data={headerData} />

                {children}

                <CommonFooter data={footerData} />


            </CommonContextProvider>
        </>
    );
};